var map = {
	"./icon-arrow-down-line.svg": 3744,
	"./icon-arrow-down.svg": 361,
	"./icon-campaign.svg": 20951,
	"./icon-chev-down-primary.svg": 83771,
	"./icon-chev-down.svg": 78478,
	"./icon-chev-left.svg": 88645,
	"./icon-chev-right.svg": 8712,
	"./icon-chev-up-primary.svg": 66112,
	"./icon-close.svg": 69827,
	"./icon-dashboard-alt.svg": 19897,
	"./icon-dashboard.svg": 5991,
	"./icon-date.svg": 7509,
	"./icon-done.svg": 50093,
	"./icon-download.svg": 90357,
	"./icon-edit.svg": 55837,
	"./icon-info.svg": 63029,
	"./icon-loading.svg": 16767,
	"./icon-logout.svg": 69855,
	"./icon-menu.svg": 88420,
	"./icon-minus.svg": 49875,
	"./icon-plus.svg": 89653,
	"./icon-search-sm.svg": 26678,
	"./icon-setting-sm.svg": 10352,
	"./icon-setting.svg": 67923,
	"./icon-three-dot.svg": 55737,
	"./icon-tnc.svg": 69682,
	"./icon-upload.svg": 79298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;